// modules/orders/actions
export const actions = {
    GET_ORDER: 'GET_ORDER',
    GET_ORDER_SUCCESS: 'GET_ORDER_SUCCESS',
    GET_ORDER_FAILED: 'GET_ORDER_FAILED',
    GET_CURRENT_ORDERS_LIST: 'GET_CURRENT_ORDERS_LIST',
    GET_CURRENT_ORDERS_LIST_SUCCESS: 'GET_CURRENT_ORDERS_LIST_SUCCESS',
    GET_CURRENT_ORDERS_LIST_FAILED: 'GET_CURRENT_ORDERS_LIST_FAILED',
    GET_PAST_ORDERS_LIST: 'GET_PAST_ORDERS_LIST',
    GET_PAST_ORDERS_LIST_SUCCESS: 'GET_PAST_ORDERS_LIST_SUCCESS',
    GET_PAST_ORDERS_LIST_FAILED: 'GET_PAST_ORDERS_LIST_FAILED',
    GET_PAST_ORDERS_MISSING_FEEDBACK: 'GET_PAST_ORDERS_MISSING_FEEDBACK',
    REORDER: 'REORDER',
    SET_COMMENT: 'SET_COMMENT',
    SET_RATING: 'SET_RATING',
    DISPLAY_FEEDBACK_MODAL: 'DISPLAY_FEEDBACK_MODAL',
    SUBMIT_FEEDBACK: 'SUBMIT_FEEDBACK',
    SUBMIT_FEEDBACK_SUCCESS: 'SUBMIT_FEEDBACK_SUCCESS',
    SUBMIT_FEEDBACK_FAILED: 'SUBMIT_FEEDBACK_FAILED',
    GET_LAST_CURRENT_ORDERS_LIST: 'GET_LAST_CURRENT_ORDERS_LIST',
    GET_LAST_CURRENT_ORDERS_LIST_SUCCESS: 'GET_LAST_CURRENT_ORDERS_LIST_SUCCESS',
    GET_LAST_CURRENT_ORDERS_LIST_FAILED: 'GET_LAST_CURRENT_ORDERS_LIST_FAILED',
    GET_LAST_PAST_ORDERS_LIST: 'GET_LAST_PAST_ORDERS_LIST',
    GET_LAST_PAST_ORDERS_LIST_SUCCESS: 'GET_LAST_PAST_ORDERS_LIST_SUCCESS',
    GET_LAST_PAST_ORDERS_LIST_FAILED: 'GET_LAST_PAST_ORDERS_LIST_FAILED',
    // Order Status
    START_POLLING_ORDER_STATUS: 'START_POLLING_ORDER_STATUS',
    STOP_POLLING_ORDER_STATUS: 'STOP_POLLING_ORDER_STATUS',
    GET_ORDER_STATUS: 'GET_ORDER_STATUS',
    GET_ORDER_STATUS_SUCCESS: 'GET_ORDER_STATUS_SUCCESS',
    GET_ORDER_STATUS_FAILED: 'GET_ORDER_STATUS_FAILED',
    REMOVE_CURRENT_ORDER: 'REMOVE_CURRENT_ORDER',
    // Order Delivery
    GET_ORDER_DELIVERY_SUCCESS: 'GET_ORDER_DELIVERY_SUCCESS',
    GET_ORDER_DELIVERY_FAILED: 'GET_ORDER_DELIVERY_FAILED',
    SET_ACTIVE_ORDERS_COUNT: 'SET_ACTIVE_ORDERS_COUNT',

    // Order status change
    SET_CURRENT_ORDER_STATUS: 'SET_CURRENT_ORDER_STATUS',

    // delivered/ pickedup order details
    GET_ORDER_DETAILS: 'GET_ORDER_DETAILS',
    GET_ORDER_DETAILS_SUCCESS: 'GET_ORDER_DETAILS_SUCCESS',
    GET_ORDER_DETAILS_FAILED: 'GET_ORDER_DETAILS_FAILED',

    SHOW_REORDER_ERROR_MSG: 'SHOW_REORDER_ERROR_MSG',
    SET_IS_REORDER: 'SET_IS_REORDER',
}

export const getCurrentOrdersList = () => ({
    type: actions.GET_CURRENT_ORDERS_LIST,
})

export const getCurrentOrdersListSuccess = result => ({
    type: actions.GET_CURRENT_ORDERS_LIST_SUCCESS,
    payload: result,
})

export const getCurrentOrdersListFailed = error => ({
    type: actions.GET_CURRENT_ORDERS_LIST_FAILED,
    payload: error,
})

export const getPastOrdersList = next => ({
    type: actions.GET_PAST_ORDERS_LIST,
    payload: next,
})

export const getPastOrdersListSuccess = result => ({
    type: actions.GET_PAST_ORDERS_LIST_SUCCESS,
    payload: result,
})

export const getPastOrdersListFailed = error => ({
    type: actions.GET_PAST_ORDERS_LIST_FAILED,
    payload: error,
})

export const setComment = payload => ({
    type: actions.SET_COMMENT,
    payload,
})

export const setRating = payload => ({
    type: actions.SET_RATING,
    payload,
})

export const displayFeedbackModal = payload => ({
    type: actions.DISPLAY_FEEDBACK_MODAL,
    payload,
})

export const submitFeedback = payload => ({
    type: actions.SUBMIT_FEEDBACK,
    payload,
})

export const submitFeedbackSuccess = () => ({
    type: actions.SUBMIT_FEEDBACK_SUCCESS,
})

export const submitFeedbackFailed = () => ({
    type: actions.SUBMIT_FEEDBACK_FAILED,
})

export const reorder = order => ({
    type: actions.REORDER,
    payload: order,
})

// Order Status
export const startPollingForOrderStatus = orderId => ({
    type: actions.START_POLLING_ORDER_STATUS,
    payload: orderId,
})

export const stopPollingForOrderStatus = () => ({
    type: actions.STOP_POLLING_ORDER_STATUS,
})

export const getOrderStatus = orderId => ({
    type: actions.GET_ORDER_STATUS,
    payload: orderId,
})

export const getOrderStatusSuccess = order => ({
    type: actions.GET_ORDER_STATUS_SUCCESS,
    payload: order,
})

export const getOrderStatusFailed = err => ({
    type: actions.GET_ORDER_STATUS_FAILED,
    payload: err,
})

export const removeCurrentOrder = () => ({
    type: actions.REMOVE_CURRENT_ORDER,
})

// Order Delivery
export const startPollingForOrderDelivery = order => ({
    type: actions.START_POLLING_ORDER_DELIVERY,
    payload: order,
})

export const stopPollingForOrderDelivery = () => ({
    type: actions.STOP_POLLING_ORDER_DELIVERY,
})

export const getOrderDeliverySuccess = order => ({
    type: actions.GET_ORDER_DELIVERY_SUCCESS,
    payload: order,
})

export const getOrderDeliveryFailed = err => ({
    type: actions.GET_ORDER_DELIVERY_FAILED,
    payload: err,
})

export const setActiveOrdersCount = count => ({
    type: actions.SET_ACTIVE_ORDERS_COUNT,
    payload: count,
})

// recent orders only
export const getLastCurrentOrdersList = () => ({
    type: actions.GET_LAST_CURRENT_ORDERS_LIST,
})

export const getLastCurrentOrdersListSuccess = result => ({
    type: actions.GET_LAST_CURRENT_ORDERS_LIST_SUCCESS,
    payload: result,
})

export const getLastCurrentOrdersListFailed = error => ({
    type: actions.GET_LAST_CURRENT_ORDERS_LIST_FAILED,
    payload: error,
})

export const getLastPastOrdersList = () => ({
    type: actions.GET_LAST_PAST_ORDERS_LIST,
})

export const getLastPastOrdersListSuccess = result => ({
    type: actions.GET_LAST_PAST_ORDERS_LIST_SUCCESS,
    payload: result,
})

export const getLastPastOrdersListFailed = error => ({
    type: actions.GET_LAST_PAST_ORDERS_LIST_FAILED,
    payload: error,
})

export const getOrderDetails = orderId => ({
    type: actions.GET_ORDER_DETAILS,
    payload: orderId,
})

export const getOrderDetailsSuccess = result => ({
    type: actions.GET_ORDER_DETAILS_SUCCESS,
    payload: result,
})

export const getOrderDetailsFailed = error => ({
    type: actions.GET_ORDER_DETAILS_FAILED,
    payload: error,
})

export const showReOrderErrorMsg = payload => ({
    type: actions.SHOW_REORDER_ERROR_MSG,
    payload,
})

export const setIsReOrder = payload => ({
    type: actions.SET_IS_REORDER,
    payload,
})